import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
const benefits = [{
  title: 'Flexibility & Convenience',
  description: 'Study when and where it works for you. Online programs are built for working adults, so you can keep your job and family life while you earn your degree.'
}, {
  title: 'Career Advancement',
  description: 'Employers increasingly value online degrees from accredited schools. Build the skills you need for a promotion or a career change without stepping away from work.'
}];
const steps = [{
  title: 'Tell us about your goals',
  description: 'Answer a few quick questions about your area of interest, current education level, and how to reach you.'
}, {
  title: 'Get matched instantly',
  description: 'We filter hundreds of accredited programs to surface the ones that actually fit what you told us.'
}, {
  title: 'Compare and decide',
  description: 'Hear directly from the schools, compare your options side by side, and take the next step when you are ready.'
}];
export function SEOContentSection() {
  return <section className="w-full bg-surface py-14 md:py-20" data-id="element-864" data-mp="wz3mrvvnfhob">
      <div className="max-w-4xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-865" data-mp="s00mspuj01n7">
        <div className="text-center max-w-2xl mx-auto" data-id="element-866" data-mp="rypnp3c0zi2f">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-4" data-id="element-867" data-mp="nxm5wbaf3byk">
            Why Choose an Online Degree?
          </h2>
          <p className="text-base md:text-lg text-ink-secondary leading-relaxed" data-id="element-868" data-mp="j1yhvz7o8oun">
            Online education has changed how adults reach their academic and
            career goals. Flexible scheduling, lower overall costs, and the same
            coursework as on-campus programs make your degree a smart
            investment.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mt-12" data-id="element-869" data-mp="ae07s92u0w0">
          {benefits.map(benefit => <article key={benefit.title} className="flex h-full flex-col rounded-2xl border border-hairline bg-background-alt p-6 sm:p-7" data-id="element-870" data-mp="3rg766v35uth0">
              <h3 className="flex items-center gap-2 text-lg sm:text-xl font-bold leading-snug text-ink" data-id="element-871" data-mp="3mhcmzs1a72wd">
                <CheckCircleIcon className="w-5 h-5 flex-shrink-0 text-accent" aria-hidden="true" data-id="element-872" data-mp="3crnmjh5gos7l" />
                {benefit.title}
              </h3>
              <p className="mt-2 text-sm sm:text-base leading-relaxed text-ink-secondary" data-id="element-873" data-mp="32vausoth8ofh">
                {benefit.description}
              </p>
            </article>)}
        </div>

        <div className="mt-16" data-id="element-874" data-mp="3vjq54y1nyikh">
          <h2 className="text-2xl md:text-3xl font-bold text-ink mb-3" data-id="element-875" data-mp="3vkhpfcpt8tvg">
            How Our Matching Service Works
          </h2>
          <p className="text-base text-ink-secondary leading-relaxed mb-8 max-w-2xl" data-id="element-876" data-mp="4cdjo6tqziyr">
            Finding the right school can feel overwhelming. We keep it simple by
            connecting you with accredited schools that match what you're
            actually looking for.
          </p>

          <ol className="space-y-6" data-id="element-877" data-mp="ibd75b5ixrtc">
            {steps.map((step, index) => <li key={step.title} className="flex items-start gap-4" data-id="element-878" data-mp="n3wmacjv0v09" data-mpi={index}>
                <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-primary text-sm font-bold text-white" aria-hidden="true" data-id="element-879" data-mp="27u1zip4cwxun">
                  {index + 1}
                </span>
                <div data-id="element-880" data-mp="2hkd50g3ovf3n">
                  <strong className="block text-base font-semibold text-ink" data-id="element-881" data-mp="2hitsn0l5lo75">
                    {step.title}
                  </strong>
                  <p className="mt-1 text-sm sm:text-base leading-relaxed text-ink-secondary" data-id="element-882" data-mp="2cmv5fgbkac8b">
                    {step.description}
                  </p>
                </div>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}